define([
    "jquery",
    "underscore",
    "marionette",
    "e_calendar",
], function ($, _, Marionette, eCalendar) {
    return Marionette.View.extend({
        el: '#header_layout',

        ui: {
            'menuTabs': '.gnb > li',
            'menuBox': '.gnb_list > div',
            'closePopover': '.close_popover',
            'popover': '#e_calendar_toggle',
            'popoverContent': '#e_calendar_popover_content',
            'popoverTitle': '#e_calendar_popover_title',

            'flags': '#flags_popup',
            'openFlags': '.open_flags_popup',

            'mainMenu': '.main-menu',
            'mainMenuPopup': '.main-menu-popup',
            'closeMenuPopup': '.close-menu-popup',
            'langCloseBtn': '.lang-close-btn',

            'navItem': 'li.pc-nav-item',
        },

        events: {
            'mouseover @ui.menuTabs': 'hoverMenu',
            'mouseleave  @ui.menuBox': 'hideMenu',
            'click @ui.closePopover': 'togglePopover',
            'click @ui.popover': 'togglePopover',
            'click @ui.openFlags': 'toggleClick',

            'click @ui.closeMenuPopup': 'closeMenuClick',
            'click @ui.mainMenu': 'mainMenuClick',
            'click @ui.langCloseBtn': 'langCloseClick',
        },

        initialize: function () {
            var that = this;

            this.bindUIElements();

            this.ui.popover.popover({
                content: function () {
                    return that.ui.popoverContent.html()
                },
                title: function () {
                    return that.ui.popoverTitle.html()
                }
            });

            var config = {
                rows: 10,
                columns: "date,time,country,event,volatility",
                selector: "#e_calendar_popover_content"
            };

            eCalendar(config);

            this.hideNavItem();

            // click anywhere to close language popup if it is opened
            // except popup area.
            $(document).mouseup(function (e){
                const clickedTarget = e.currentTarget.activeElement.className;

                if(clickedTarget != 'open_flags_popup') {
                    const flagPopupStatus = $("#flags_popup").css('display') == 'block' ? 'opened' : 'closed';

                    if(flagPopupStatus == 'opened') {
                        $("#flags_popup").css("display", "none");
                        $('body').removeClass('noscroll');
                    }
                }
            });
        },

        hideNavItem: function () {
            this.ui.navItem.each(function () {
                const $item = $(this);
                const $submenu = $item.find('ul.pc-nav-depth2');
                const hasChildren = $submenu.children('li').length > 0;

                if (!hasChildren) $item.hide();
            });
        },

        toggleClick: function (e) {
            if (e) e.preventDefault();
            const flagPopupStatus = this.ui.flags.css('display') == 'none' ? 'closed' : 'opened';

            if(flagPopupStatus == 'opened') {
                this.flagPopupClose();
                return;
            }
            $('body').addClass('noscroll');
            this.ui.flags.css('display', 'block');
        },

        flagPopupClose: function () {
            this.ui.flags.css('display', 'none');
            $('body').removeClass('noscroll');
        },

        togglePopover: function (e) {
            if (e) e.preventDefault();
            this.ui.popover.popover('toggle');
        },

        hoverMenu: function (e) {
            var idx = $(e.currentTarget).index();

            $(e.currentTarget).addClass('on').siblings().removeClass('on');

            if ($(e.currentTarget).hasClass('on')) {
                $('.gnb_list > div').eq(idx).addClass('active').siblings().removeClass('active');
            }

        },

        hideMenu: function (e) {
            if ($(e.currentTarget).hasClass('active')) {
                $(e.currentTarget).removeClass('active');
                $('.gnb li').removeClass('on');
            }
        },

        closeMenuClick: function (e) {
            this.ui.mainMenuPopup.removeClass("active");
        },

        mainMenuClick: function (e) {
            this.ui.mainMenuPopup.addClass("active");
            this.ui.flags.css("display", "none")
        },

        langCloseClick: function (e) {
            this.ui.flags.css("display", "none");
            $('body').removeClass('noscroll');
        },
    });
})